export default "__VITE_ASSET__e631f4f4__"